var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBtnToggleListProspect(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "16px",
    viewBox: "0 0 13 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "btnToggleListProspect") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.0093689 C0,0.451909848 0.447489426,0 0.998502329,0 L12.0014977,0 C12.5529553,0 13,0.443353176 13,1.0093689 L13,2.9906311 C13,3.54809015 12.5525106,4 12.0014977,4 L0.998502329,4 C0.44704472,4 0,3.55664682 0,2.9906311 L0,1.0093689 Z M0,7.0093689 C0,6.45190985 0.447489426,6 0.998502329,6 L12.0014977,6 C12.5529553,6 13,6.44335318 13,7.0093689 L13,8.9906311 C13,9.54809015 12.5525106,10 12.0014977,10 L0.998502329,10 C0.44704472,10 0,9.55664682 0,8.9906311 L0,7.0093689 Z M0,13.0093689 C0,12.4519098 0.447489426,12 0.998502329,12 L12.0014977,12 C12.5529553,12 13,12.4433532 13,13.0093689 L13,14.9906311 C13,15.5480902 12.5525106,16 12.0014977,16 L0.998502329,16 C0.44704472,16 0,15.5566468 0,14.9906311 L0,13.0093689 Z",
    id: "btnToggleListProspect",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnToggleListProspect);
export default __webpack_public_path__ + "static/media/btnToggleListProspect.bb56fb93a5b14881e2b8b605ac254804.svg";
export { ForwardRef as ReactComponent };